// src/app/hooks/nav/use-open-actions-count.ts
//
// The count on the Action Items row in the nav rail (UPM-140). It reuses the
// EXISTING open-actions query rather than adding an endpoint: the same
// getFixActionsPageData call the Action Items module itself makes.
//
// Returns undefined until it resolves, so the row renders without a count
// rather than flashing a zero.
import { useEffect, useState } from "react";
import { fixActionsService } from "@/app/services/fix-actions/fix-actions-service";

/** Statuses that are NOT open work. Anything else counts as open. */
const CLOSED = new Set(["completed", "archived"]);

export function useOpenActionsCount(brandId?: string): number | undefined {
  const [count, setCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    const id = (brandId || "").trim();
    if (!id || id === "default") { setCount(undefined); return; }
    let alive = true;
    fixActionsService
      .getFixActionsPageData({ brandId: id })
      .then((data: any) => {
        if (!alive) return;
        const actions: any[] = Array.isArray(data?.actions) ? data.actions : [];
        setCount(actions.filter((a) => !CLOSED.has(String(a?.status || "").toLowerCase())).length);
      })
      .catch(() => { if (alive) setCount(undefined); });
    return () => { alive = false; };
  }, [brandId]);

  return count;
}
